module.exports = __webpack_public_path__ + "img/book-default.512ad56d.jpg";